import React from 'react'
import '../../scss/variables.scss'
import '../../scss/reset.scss'
import './NavbarArrow.scss'
import { Link } from 'react-router-dom'


/* ===Import IMGS=== */
import BackArrow from '../../assets/images/BackArrow.svg'
import Hamburger from '../../assets/images/Hamburger.svg'

function NavbarLogo(props) {
    

    return (
        <nav>
            <Link to={props.arrowPath}>
                <img src={BackArrow} className="BackArrow" alt="FadyLogo" />
            </Link>
            <img src={Hamburger} className="Hamburger" id="HamburgerID" alt="Menu" />
        </nav> 
    )
}

export default NavbarLogo